
<div class="container-fluid">
    <div class="row">
        <div class="col-md-3 faqs_left_wrapper">
            <div>
                <div class="logo_wrapper" >
                    <h3 class="r_type activeClass" id="tenant" (click)="queryFor('tenant')" >Tenants   </h3>
                    <h3 class="r_type" id="owner" (click)="queryFor('owner')">Owners  </h3>
                </div>
            </div>
            <div>
                <div *ngIf="choiceName == 'tenant' ">    
                    <div class="dispQueries" (click)="faqParams('token')">
                        <h4 class="quer_typ"> Token and Security Deposit</h4>
                        <fa-icon [icon]="faAngleRight" class="fa-sm" ></fa-icon>
                    </div>
                    <div class="dispQueries" (click)="faqParams('moveinout')" >
                        <h4 class="quer_typ"> Move-in/Move-out </h4>
                        <fa-icon [icon]="faAngleRight" class="fa-sm" ></fa-icon>
                    </div>
                    <div class="dispQueries" (click)="faqParams('tenSRreq')" >
                        <h4 class="quer_typ"> Service Requests</h4>
                        <fa-icon [icon]="faAngleRight" class="fa-sm" ></fa-icon>
                    </div>
                    <div class="dispQueries" (click)="faqParams('tenDashboard')">
                        <h4 class="quer_typ"> Dashboard and account </h4>
                        <fa-icon [icon]="faAngleRight" class="fa-sm" ></fa-icon>
                    </div>
                    <div class="dispQueries" (click)="faqParams('tenantStay')" >
                        <h4 class="quer_typ"> Terms of stay</h4>
                        <fa-icon [icon]="faAngleRight" class="fa-sm" ></fa-icon>
                    </div>
                    <div class="dispQueries" (click)="faqParams('tenant_payment')" >
                        <h4 class="quer_typ"> Payments </h4>
                        <fa-icon [icon]="faAngleRight" class="fa-sm" ></fa-icon>
                    </div>
                    <div class="dispQueries" (click)="faqParams('tenDocument')" >
                        <h4 class="quer_typ"> Documents </h4>
                        <fa-icon [icon]="faAngleRight" class="fa-sm" ></fa-icon>
                    </div>
                </div>
                <div *ngIf="choiceName == 'owner' ">
                    <div class="dispQueries" (click)="faqParams('proplisting')" >
                        <h4 class="quer_typ"> Property Engagement</h4>
                        <fa-icon [icon]="faAngleRight" class="fa-sm" ></fa-icon>
                    </div>
                    <div class="dispQueries" (click)="faqParams('ownpayment')">
                        <h4 class="quer_typ"> Payments & deposits </h4>
                        <fa-icon [icon]="faAngleRight" class="fa-sm" ></fa-icon>
                    </div>
                    <div class="dispQueries" (click)="faqParams('ownerTenants')">
                        <h4 class="quer_typ"> Tenants</h4>
                        <fa-icon [icon]="faAngleRight" class="fa-sm" ></fa-icon>
                    </div>
                    <div class="dispQueries" (click)="faqParams('ownDocuments')">
                        <h4 class="quer_typ"> Documents</h4>
                        <fa-icon [icon]="faAngleRight" class="fa-sm" ></fa-icon>
                    </div>
                    <div class="dispQueries" (click)="faqParams('ownerdashboard')">
                        <h4 class="quer_typ"> Dashboard and account </h4>
                        <fa-icon [icon]="faAngleRight" class="fa-sm" ></fa-icon>
                    </div>
                    <div class="dispQueries" (click)="faqParams('propdelist')">
                        <h4 class="quer_typ"> Property listing & de-listing </h4>
                        <fa-icon [icon]="faAngleRight" class="fa-sm" ></fa-icon>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="col-md-8 faqs_right_wrapper"> 
            <div style="margin: 40px 0px;">
                <h1 style="text-align: center; font-weight: 600;"> Frequently Asked Questions </h1>
            </div>       
        <div class="faq_section">
            <div>  
                <div class="queries">
                    <div class="role_faqs" *ngIf="choiceName == 'tenant' ">
                        <div *ngIf="fetchParam == 'token' ">
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqs1" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What is Token ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqs1">
                                    <p class="query_ans"> Token is the one month rent to be paid at the time of booking and is not adjustable against security deposit payment at the time of move-in.</p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqs6" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Is the token refundable ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqs6">
                                    <p class="query_ans"> The token amount is refundable when you move out. However, in case of cancelled booking, token is non-refundable.</p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqs2" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What is security deposit ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqs2">
                                    <p class="query_ans">Security deposit is the 3 month rental in Bangalore and 2 month rental in Pune location that must be paid by the tenant to the owner before signing of the agreement.</p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqstok1" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Is security deposit negotiable ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqstok1">
                                    <p class="query_ans"> Security deposit is non-negotiable. </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqstok3" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What is security deposit refund process ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqstok3">
                                    <p class="query_ans"> Once the security deposit settlement process is initiated to submission of exit clearance form and cancellation of rental and service agreement, handing over the keys to YourOwnROOM team is done, refund will happen within 15 bank working days through online mode only. </p>
                                    <a [routerLink]="['/page',39,'Security deposit return terms']" > More details</a>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqstok2" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Can the token and deposit amount be paid in cash ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqstok2">
                                    <p class="query_ans"> Any payment, be it token, deposit or rent is to be paid online only. </p>
                                </div>
                            </div>
                        </div>
                        <div id="moveinout" *ngIf="fetchParam == 'moveinout' ">
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenmov4" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What is the process of moving in ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenmov4">
                                    <p class="query_ans"> Once the onboardingis complete, the tenants can move in. It is advised that the tenant completes the society move in formalities on their own as YourOwnROOM is not responsible for any delay caused in move-in.  </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqs8" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> If there's any extra society move-in charges, who will pay ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqs8">
                                    <p class="query_ans"> If there are any additional move-in charges applicable from the Society or apartment complex, the tenant will be responsible for paying the same directly to the concerned party / association.   </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqsmov3" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Is there any lock-in after moving in? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqsmov3">
                                    <p class="query_ans"> The minimum lock-in period after move-in is 6 months. After your lock-in 
                                        period is over,you can move out. </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqsmov5" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What is the move out process ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqsmov5">
                                    <p class="query_ans"> Once the exit request is made from the respective tenant dashboard, tenant can move out only after a minimum of 30 days post lock-in period.  </p>
                                    <a [routerLink]="['/page',29,'Move Out']"> More details </a>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqsmov1" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Is the house cleaning done before move-in ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqsmov1">
                                    <p class="query_ans"> House cleaning is done before every move-in. </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqsmov2" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Can i move-in before move-in date? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqsmov2">
                                    <p class="query_ans"> Any move-in is done only on the move-in date or after that.</p>
                                </div>
                            </div>
                        </div>
                        <div id="tenSRreq" *ngIf="fetchParam == 'tenSRreq' ">
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqs8" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> How to raise a service request? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqs8">
                                    <p class="query_ans"> Any service request can be raised from your service request section on dashboard.  </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenser1" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Can the request me made through email/whatsapp/phone ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenser1">
                                    <p class="query_ans"> Service request is to be raised on the platform only with full details and photos (as applicable), avoid raising the requests through email/SMS/ Whatapp messages. </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenser2" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Who pays for the services  ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenser2">
                                    <p class="query_ans"> Service request to other than standard amenities (bed, mattress, dining set, sofa set, TV, Refrigerator & Washing machine), the cost will be borne by the tenant including any willful damage to any standard amenities and or all items in the property from the day of move in to the property. </p>
                                    <a [routerLink]="['/page',31,'Service Requests']"> More details </a>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenser3" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What if some amenities are damaged and not reported ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenser3">
                                    <p class="query_ans"> In the event the tenant does not raise the service request for any damage not caused by the tenant to the property, furniture and appliances and if damages found during audit, the cost will be raised to the tenant. </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqsser1" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What are the different types of service that can be raised from the platform  </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqsser1">
                                    <p class="query_ans"> There are seven types of service request that can be raised from the platform. Keys,electrical,
                                        carpentry,furnishing,plumbing,cleaning and others are the service types that can be raised.   </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqsser2" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> How fast do the serivce requests get closed ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqsser2">
                                    <p class="query_ans"> The handling of service request depend on the availability of our team and the respective type of
                                        service experts.    </p>
                                </div>
                            </div>
                        </div>
                        <div id="tenDashboard" *ngIf="fetchParam == 'tenDashboard' ">
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqs8" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Do we get our own dashboard ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqs8">
                                    <p class="query_ans"> Every tenant is provided with a high-tech dashboard platform where they can keep themselves updated of any necessary changes.  </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqsdash1" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What to do if i am unable to access dashboard </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqsdash1">
                                    <p class="query_ans"> In case you are unable to access your dashboard, kindly inform our support team for such occurances.   </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqsdash2" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Can registered mobile number be changed ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqsdash2">
                                    <p class="query_ans"> Yes, your registered mobile number can be changed from the edit profile section in your dashboard.   </p>
                                </div>
                            </div>
                        </div>
                        <div id="tenantStay" *ngIf="fetchParam == 'tenantStay' ">
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqs8" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Terms of Stay </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqs8">
                                    <p class="query_ans"> You can move in as soon as 3-4 days once your booking is done and onboarding process is complete, but 
                                        you can move in even before if the process is completed early.  </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqsterms1" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Any specific requirements/permissions needed to keep pets ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqsterms1">
                                    <p class="query_ans"> In order to keep pets, the tenant must inform us so that we can seek owner permission on your behalf.  </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqsterms2" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Can we bring guests for stay ?</h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqsterms2">
                                    <p class="query_ans"> The tenants Servant or Guests or Relatives are not allowed to stay in the property beyond 10:00PM.   </p>
                                    <a > More details </a>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqsterms4" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What to do if agreement is to be extended ?</h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqsterms4">
                                    <p class="query_ans"> Tenants must confirm and renew the agreement minimum 45 days prior to the expiry of their rental agreement.  </p>
                                    <a [routerLink]="['/page',26,'Renewal of tenancy']"> More details </a>
                                </div>
                            </div>
                        </div>
                        <div id="tenant_payment" *ngIf="fetchParam == 'tenant_payment' ">
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqs3" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> How to pay monthly rent ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqs3">
                                    <p class="query_ans"> You will have to pay the monthly rent from your own dashboard by online mode. </p>
                                    <a [routerLink]="['/page',38,'How to Pay Rent']"> More details </a>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenrent1" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> How to rent charged ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenrent1">
                                    <p class="query_ans"> Rent is charged from the chosen date of move-in as per signed rental agreement. </p>
                                    <a [routerLink]="['/page',15,'Rent']"> More details </a>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenrent2" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Is there any late charge fine for rent ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenrent2">
                                    <p class="query_ans"> Non-payment of rent post due date as per invoice will attract a one-time penalty of INR 1,000 (Rupees One Thousand). </p>
                                    <a [routerLink]="['/page',55,'Rate Card']"> More details </a>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqs4" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Is the property rent negotiable ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqs4">
                                    <p class="query_ans"> The house owners are the ones that generally fixes the proeprty rent and is non-negotiable.</p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqs5" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Are there any other monthly expenses involved ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqs5">
                                    <p class="query_ans"> The water, electricity, cooking gas, internet, DTH, society amenities etc. are not the part of the monthly rent.  </p>
                                </div>
                            </div>
                        </div>
                        <div id="tenDocument" *ngIf="fetchParam == 'tenDocument' ">
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqs7" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What are the documents needed for onboarding ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqs7">
                                    <p class="query_ans"> Aadhar and Pan Card are mandatory documents needed for onboarding. Any other documents such as 
                                        Passport, Driving License, Voter card are optional. </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqsdoc1" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What is rental agreement ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqsdoc1">
                                    <p class="query_ans"> Rental agreement is a police verified agreement that is signed by both, the owner and tenants involved
                                        and the confirmation is done after signing by both involved parties.  </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#tenfaqsdoc2" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Can i change my documents from dashboard ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="tenfaqsdoc2">
                                    <p class="query_ans"> Once the mandatory documents submitted are verified, then those cannot be changed.  </p>
                                </div>
                            </div>
                        </div>          
                    </div>
<!---------------------------------------------------------- Owner listings -------------------------->
                    <div class="role_faqs" *ngIf="choiceName == 'owner' ">
                        <div id="proplisting" *ngIf="fetchParam == 'proplisting' ">
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqs1" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What is engagement process with us ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqs1">
                                    <p class="query_ans"> On Engagement with YourOwnROOM, the owner agrees to list and rent out the property to prospect tenant on the YourOwnROOM online platform.</p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqs2" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> How is the house inspection done during property listing ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqs2">
                                    <p class="query_ans"> House inspection is done......</p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqs4" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What are the things done before property engagement with us ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqs4">
                                    <p class="query_ans"> The owner will resolve all outstanding bills like electricity, water, Maintenance, Club membership fees (as applicable) and any other dues related to the property to the society as per their defined schedule of payment.</p>
                                    <a [routerLink]="['/page',34,'Engaging Yourownroom']">More details </a>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqs3"  role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What are the things owner needs to provide the company ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqs3">
                                    <p class="query_ans"> The owner needs to provide a set of keys to be handed over to YourOwnROOM for showing the apartment to prospects. The owner will share the information on latest payment of land and revenue taxes, rates, cesses and any other dues with respect of the Flat as assessed to the regulatory board. </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqs5" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Should the property be repaired before handing over to the company ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqs5">
                                    <p class="query_ans">  The owner needs to finish the repairs and ensure the property is free of all maintenance issues before leasing the apartment.  </p>
                                </div>
                            </div>
                        </div> 
                        <div *ngIf="fetchParam == 'ownpayment' ">
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqs5" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Can we get rent statement ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqs5">
                                    <p class="query_ans"> Rent statement can be obtained from the respective owner dashboard.</p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqsrent" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> When will the owner receive rent payment ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqsrent">
                                    <p class="query_ans"> The owner will accept the rent from YourOwnROOM for the month, on the 12 th day of the month or as per the agreed terms in the agreement.</p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqsrent1" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> When to return the security deposit ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqsrent1">
                                    <p class="query_ans"> The owner will return the security deposit with in a period of 10 days at maturity or early termination of the Agreement after receiving the final settlment confirmation from YourOwnROOM. </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqsrent2" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Change house/bed rent </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqsrent2">
                                    <p class="query_ans"> Rent for any house/bed can be changed after informing us.</p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqsrent3" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What if tenant doesn't pay rent on time ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqsrent3">
                                    <p class="query_ans"> If the tenant doesn't pay the rent on time, they will be emailed of the 
                                        development and action will be taken against them.
                                    </p>
                                </div>
                            </div>
                        </div> 
                        <div *ngIf="fetchParam == 'ownerTenants' ">
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqsten3" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Select type of tenant to stay in your house </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqsten3">
                                    <p class="query_ans"> The owner is given the choice during property listing to select single, co-living or family housing.</p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqs6" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Can i make any bookings after listing property with YourOwnROOM ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqs6">
                                    <p class="query_ans"> No, after the flat is listed with us, owner cannot accept any bookings without 
                                        informing our team.
                                    </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqs7" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Do owners need to be present during tenant move-in and move-outs ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqs7">
                                    <p class="query_ans"> We take care of all the move-in and move-out of the tenants.</p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqsten1" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What if tenant is found involved in illegal activities? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqsten1">
                                    <p class="query_ans"> If any tenant is found involved in illegal activities, their contract will be exterminated.</p>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="fetchParam == 'ownDocuments' ">
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqsdoc1" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What are the documents required from owners for property listing ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqsdoc1">
                                    <p class="query_ans"> If a property listed by the owner is approved by our team, then owner is required to submit Aadhar, Pan card as the mandatory documents. </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqsdoc2" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What is rental agreement ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqsdoc2">
                                    <p class="query_ans"> Rental agreement is a police verified agreement that is signed by both, the owner and tenants involved
                                        and the confirmation is done after signing of both involved parties.  </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqsdoc3" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> where can i find the agreement of all my tenants  ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqsdoc3">
                                    <p class="query_ans"> The agreement of each and every tenant listed in your property can be found on your owner dashboard
                                        in the individual property section.  </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqsdoc4" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What is the validity of agreement ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqsdoc4">
                                    <p class="query_ans"> Any agreement generated is a one year contract signed by both parties and can be renewed after
                                        paying the agreement charges. </p>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="fetchParam == 'ownerdashboard' ">
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqsdash1" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Do owner get their own dashboard ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqsdash1">
                                    <p class="query_ans"> After completion of the property listing process, the owner is provided with a high end dashboard
                                        to keep themselves updated with their properties.
                                    </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqsdash2" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> What to do if i am unable to access dashboard </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqsdash2">
                                    <p class="query_ans"> In case you are unable to access your dashboard, kindly inform our support team for such occurances.   </p>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqsdash3" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> Can registered mobile number be changed ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqsdash3">
                                    <p class="query_ans"> Yes, your registered mobile number can be changed from the edit profile section in your dashboard.   </p>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="fetchParam == 'propdelist' ">
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownlist1" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> How to list a property ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownlist1">
                                    <p class="query_ans"> </p>
                                    <a [routerLink]="['/page',72,'Property Onboarding']"> More details </a>
                                </div>
                            </div>
                            <div class="accords">
                                <div class="faq_ques" data-toggle="collapse" href="#ownfaqs10" role="button" aria-expanded="false">
                                    <div class="ques_wrapper">
                                        <h3 class="faq_query_question" style="margin: 0;"> How to de-list property ? </h3>
                                        <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                                    </div>
                                </div>
                                <div class="collapse faq_ans" id="ownfaqs10">
                                    <p class="query_ans"> The Landlord or the Company shall give a written notice of 30 (thirty) days to terminate the agreement.
                                        Tenants will be intimated of Property exit and the exit date for tenants will be set accordingly.</p>
                                    <a [routerLink]="['/page',73,'Property Offboarding']"> More details </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section_helpful">
            <div class="help_section">
                <h2 style="text-align: center; font-size: 16px;"> Was this page helpful ?</h2>
                <div style="display: flex; justify-content: space-evenly;">
                    <!-- <div style="display: flex; justify-content: space-evenly; width: 60%;"> -->
                        <div class="thumbs_icon" id="yes">
                            <fa-icon [icon]="faThumbsUp" class="fa-2x" style="color: #0A9CDD;" (click)="wasHelpful(1);" ></fa-icon>
                        </div>
                        <div class="thumbs_icon" id="no">
                            <fa-icon [icon]="faThumbsDown" class="fa-2x" style="color: #E01D24;" (click)="wasHelpful(2);"> </fa-icon>
                        </div>
                    <!-- </div> -->
                </div>
            </div>
        </div>
        <div *ngIf="notfs == true">
            <p style="text-align: center; font-size: 16px; color: #989898;"> 
                <img src="assets/images/yor_logo.png" style="width: 20px;"> 
                {{ dispMsg }} </p>
        </div>
    </div>
</div>
</div>
